import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '@/lang/lang'

import Fingerprint2 from 'fingerprintjs2'
import { getColorText } from '@/utils/helper-functions'
import {statsActive, platform} from '@/utils/constants'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appLoaded: false,
    userLoaded: false,
    accessToken: null,
    refreshToken: null,
    azureUser: null,
    client: null,
    device: null,
    user: null,
    contentStack: [],
    purchase: null,
    muted: true,
    shopCategories: []
  },
  // cambian valor de estado (NO INCLUIR LLAMADAS ASINCRONAS)
  mutations: {
    setToken (state, payload) {
      state.accessToken = payload.accessToken
      state.refreshToken = payload.refreshToken
      localStorage.setItem('access_token', payload.accessToken)
      localStorage.setItem('refresh_token', payload.refreshToken)
      if (payload.azureUser) {
        state.azureUser = payload.azureUser
        localStorage.setItem('azure_user', payload.azureUser)
      } else {
        localStorage.removeItem('azure_user')
      }
    },
    setUser (state, payload) {
      if (payload) {
        state.user = payload
        // cambiamos idioma
        if (state.user.country2 && state.user.country2.language.locale) {
          if (state.user.country2.language.locale in i18n.messages) i18n.locale = state.user.country2.language.locale
        }
      } else {
        state.user = null
      }
      // controla la carga inicial de la app
      state.userLoaded = true
    },
    setClient (state, payload) {
      state.client = payload
      document.title = payload.display_name
      document.querySelector('meta[name="Description"]').setAttribute('content', state.client.display_name)

      // create custom css
      this.dispatch('loadStyles')
      // load bg
      this.dispatch('loadBg', { img: state.client.background })
      // load device
      this.dispatch('loadSettingsTv')
      // load Countly
      this.dispatch('loadCountly')
    },
    setDevice (state, payload) {
      state.device = payload
    },
    contentStackPush (state, payload) {
      state.contentStack.push(payload)
    },
    contentStackPop (state) {
      state.contentStack.pop()
    },
    setPurchase (state, payload) {
      state.purchase = payload
    },
    setMuted (state, payload) {
      state.muted = payload
    },
    shopCategories (state, payload) {
      state.shopCategories = payload
    }
  },
  // acciones que no mutan estado (lógica, manipulaciones, apis...)
  actions: {
    loadStyles () {
      let bgColor1 = getColorText(this.state.client.color1)
      let bgColor2 = getColorText(this.state.client.color2)

      let style = document.createElement('style')
      style.type = 'text/css'
      style.innerHTML = '' +
      // NAVBAR
      // '#wrapper-navbar:focus a.router-link-exact-active {' +
      //       'border-bottom-color: ' + color + '!important;' +
      //   '}' +
      '#wrapper-navbar .nav-link:focus a{' +
            'border-bottom-color: ' + bgColor1 + '!important;' +
        '}' +
      // LISTAS
      '.container-list:focus .item.active .text {' +
        'background-color: ' + this.state.client.color2 + '!important;' +
        'color: ' + bgColor2 + '!important;' +
      '}' +
      '.container-list:focus .item.active .card-data {' +
        'opacity: 1!important;' +
        'border-color: rgba(66, 66, 66, .5)!important;' +
      '}' +
      '.container-list:focus .item.active {' +
        'outline-color: ' + this.state.client.color2 + '!important;' +
      '}' +
      // GRID
      // '.container-grid .focusable:focus .text {' +
      //   'background-color: ' + this.state.client.color2 + '!important;' +
      //   'color: ' + color + '!important;' +
      // '}' +
      // BUTTONS
      // '.btn-large {' +
      //   'border: 1px solid ' + color + '!important;' +
      // '}' +
      '.btn-large:focus, .btn:focus {' +
        'background-color: ' + this.state.client.color2 + '!important;' +
        'color: ' + bgColor2 + '!important;' +
      '}' +
      '.wrapper-features-focusable:focus .btn, .wrapper-features-focusable:focus .wrapper-icon{' +
        'background-color: ' + this.state.client.color2 + '!important;' +
        'color: ' + bgColor2 + '!important;' +
      '}' +
      '#wrapper-total:focus .btn-large {' +
        'background-color: ' + this.state.client.color2 + '!important;' +
        'color: ' + bgColor2 + '!important;' +
      '}' +
      // FORMS
      // '.form-app input:focus {' +
      //   'border-bottom: 1px solid ' + this.state.client.color1 + '!important;' +
      //   'box-shadow: 0 1px 0 0 ' + this.state.client.color1 + '!important;' +
      // '}' +
      ''
      if (platform === 'browser') {
        style.innerHTML = '' +
        // BROWSER
        '.btn-large:hover, .btn:hover {' +
          'background-color: ' + this.state.client.color2 + '!important;' +
          'color: ' + bgColor2 + '!important;' +
        '}'
      }

      document.getElementsByTagName('head')[0].appendChild(style)
    },
    loadBg (state, payload) {
      let loaded = () => { setTimeout(() => { this.state.appLoaded = true }, 0) }

      let bgImg = new Image()
      bgImg.onload = loaded
      bgImg.onerror = loaded
      bgImg.src = payload.img
    },
    loadSettingsTv () {
      // device
      document.addEventListener('deviceready', () => {
        // eslint-disable-next-line
        this.commit('setDevice', device)
        // generamos uuid para webos1, webos2 y emuladores
        if (!this.state.device.uuid) { new Fingerprint2().get((uuid) => { this.state.device.uuid = uuid }) }

        // registramos teclas
        if (typeof (toast) !== 'undefined') {
          // eslint-disable-next-line
          toast.inputdevice.registerKey('MediaPlayPause', function () { })
          // eslint-disable-next-line
          toast.inputdevice.registerKey('MediaPlay', function () { })
          // eslint-disable-next-line
          toast.inputdevice.registerKey('MediaPause', function () { })
          // eslint-disable-next-line
          toast.inputdevice.registerKey('MediaRewind', function () { })
          // eslint-disable-next-line
          toast.inputdevice.registerKey('MediaFastForward', function () { })
          // eslint-disable-next-line
          toast.inputdevice.registerKey('MediaStop', function () { })
        }
      })

      // let loadToast = () => {
      //   // toast
      //   let toastJS = document.createElement('script'); toastJS.type = 'text/javascript'
      //   toastJS.async = true
      //   toastJS.src = 'toast.js'
      //   let s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(toastJS, s)
      // }

      // // cordova
      // let cordobaJS = document.createElement('script'); cordobaJS.type = 'text/javascript'
      // cordobaJS.async = true
      // cordobaJS.src = 'cordova.js'
      // cordobaJS.onload = loadToast
      // let s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(cordobaJS, s)
    },
    loadCountly () {
      // ANALYTICS
      if (statsActive && process.env.NODE_ENV !== 'development' && window.Countly) {
        window.Countly.init({
          app_key: this.state.client.statistics_api_key,
          url: this.state.client.statistics_url
        })

        // track sessions automatically
        window.Countly.track_sessions()
      } else {
        window.Countly = {}
        window.Countly.q = []
      }
    }
  },
  getters: {
    appLoaded (state) {
      return state.appLoaded && state.userLoaded
    },
    loggedIn (state) {
      return state.user
    },
    getToken (state) {
      return state.accessToken
    },
    getRefreshToken (state) {
      return state.refreshToken
    },
    client (state) {
      return state.client
    },
    user (state) {
      return state.user
    },
    device (state) {
      return state.device
    },
    contentStackTop (state) {
      if (state.contentStack.length) {
        return state.contentStack[state.contentStack.length - 1]
      } else {
        return false
      }
    },
    purchase (state) {
      return state.purchase
    },
    platform (state) {
      return platform
    },
    muted (state) {
      return state.muted
    },
    shopCategories (state) {
      return state.shopCategories
    },
    getData (state) {
      return {

        // // propiedades api
        'name': state.client.name,
        'display_name': state.client.display_name,
        'logo': state.client.logo,
        // 'horizontal_logo': this.client.horizontal_logo,
        'logo_mono': state.client.logo_mono,
        'background': state.client.background,
        'background_admin': state.client.background_admin,
        'is_background_blur': state.client.is_background_blur,
        'videotype': state.client.videotype,
        'video': state.client.video,
        'content': state.client.content,
        'color1': state.client.color1,
        'color2': state.client.color2,
        // 'color3': this.client.color3,
        'is_shop': state.client.is_shop,
        'is_invoice': state.client.is_invoice,
        'type_shop': state.client.type_shop,
        // 'is_virtual_user': this.client.is_virtual_user,
        'is_buy': state.client.is_buy,
        'currency': state.client.currency,
        'terms_url': state.client.terms_url,
        'stripe_api_key': state.client.stripe_api_key,
        // //'is_background_dark': this.client.is_background_dark,
        'template1': state.client.template1, // root-categories-content
        'template2': state.client.template2, // sub-category-content
        'template3': state.client.template3, // root-categories-shop
        'template4': state.client.template4, // sub-category-shop
        'template5': state.client.template5, // content detail
        // 'template6': state.client.template6, // product
        'is_close': state.client.is_close,
        'is_subscriptions': state.client.is_subscriptions,
        'countries': state.client.countries,
        'control_bar': state.client.is_control_bar,
        'login_url': state.client.login_url,
        'is_favorite': state.client.is_favorite,
        'is_app_mobile': state.client.is_app_mobile,
        'is_zones': state.client.is_zones,
        'bucket_type': state.client.bucket_type,
        'android_app_download_url': state.client.android_app_download_url,
        'apple_app_download_url': state.client.apple_app_download_url,
        'card_categories': state.client.card_categories,
        'card_contents': state.client.card_contents,
        'card_categories_products': state.client.card_categories_products,
        'card_products': state.client.card_products,

        'email_contact': state.client.email_contact,
        'external_pay_method': state.client.external_pay_method,
        'legal_warning': state.client.legal_warning,
        'privacy_policy': state.client.privacy_policy,
        'cookies_policy': state.client.cookies_policy,
        'cookies_banner': state.client.cookies_banner,
        'compliance': state.client.compliance
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js